import React from "react";

import { Skeleton, TableCell, TableRow } from "@mui/material";

const TableLoading = ({ noOfRows = 8, noOfColumns = 13 }) => {
  return (
    <>
      {Array.from({ length: noOfRows }).map((_, rowIndex) => (
        <TableRow key={rowIndex}>
          {Array.from({ length: noOfColumns }).map((_, colIndex) => (
            <TableCell key={colIndex} sx={{ border: "none", height: "60px" }}>
              <Skeleton animation="wave" sx={{ minWidth: "40px", backgroundColor: "#f1f1f1" }} height={16} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default TableLoading;
